import { render, staticRenderFns } from "./subscriptionManage.vue?vue&type=template&id=af8f066c&scoped=true"
import script from "./subscriptionManage.vue?vue&type=script&lang=js"
export * from "./subscriptionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8f066c",
  null
  
)

export default component.exports